module.exports = __webpack_public_path__ + "static/img/illustratepic_01.75aab9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ko/illustratepic_01.png
// module id = /v8i
// module chunks = 1